import { Box, Flex, Heading, Image, Text } from '@chakra-ui/react';
import logo from 'assets/images/logo.png';
import { useRenewalQuery } from 'generated/graphql';
import { useNavigate } from 'react-router-dom';
import IFrameViewer from '../IFrameViewer';
import { useOnEsignCompleted, useToken } from '../lib';

function Renewal() {
  const navigate = useNavigate();
  const token = useToken();
  useOnEsignCompleted(() => navigate('confirmation', { state: { complete: true } }));

  const { loading, data } = useRenewalQuery({
    variables: { token },
    skip: !token.length,
  });

  if (loading || !data || !data.renewal.documentLink) return null;

  return (
    <Flex
      w="100%"
      h="100%"
      direction="column"
      align="center"
      p={10}
      borderTop="8px"
      borderColor="purple.500"
    >
      <Image src={logo} alt="LM logo" boxSize="120px" />
      <Box textAlign="center" mt={10}>
        <Heading as="h2">Welcome</Heading>
        <Heading as="h4" size="md">
          Thank you for chosing us for you real estate needs
        </Heading>
        <Box mt={2}>
          {data.renewal.usedAt ? (
            <>
              <Text>Thank you for completing the signing process!</Text>
              <Text>
                You can download your signed document by clicking the &quot;Downlaod&quot; button
                below
              </Text>
            </>
          ) : (
            <>
              <Text>Please click on &quot;Start&quot; below to start filling in your document</Text>
              <Text>Click on &quot;Finish&quot; when you have completed the form</Text>
            </>
          )}
        </Box>
      </Box>
      <Box flex={1} p={20} w="100%">
        <IFrameViewer url={data.renewal.documentLink} />
      </Box>
    </Flex>
  );
}

export default Renewal;
